import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updatePayroll } from 'src/store/actions/payroll-actions';

import { toast } from 'react-toastify';
import { IPayroll } from 'src/types/payroll';

interface Props {
    data: IPayroll;
    updateState: boolean;
    setUpdateState: (param: boolean) => void;
}

const noReload = true;

const DeletePayrollAction: React.FunctionComponent<Props> = (props: Props) => {
    const { data, setUpdateState, updateState } = props;
    const { id, status } = data;
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const [success, setSuccess] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    const isMobile = window.innerWidth <= 900;
    return (
        <>
            {success ? null : (
                <button type="button" onClick={() => setOpened(true)} className="btn-primary btn mr-1">
                    {isMobile ? 'Paid' : '$ Paid'}
                </button>
            )}
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to pay Payroll?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            dispatch(
                                updatePayroll(
                                    { status: +status, id, noReload },
                                    () => {
                                        toast.success('Status changed successfully');
                                        setSuccess(true);
                                        props.data.status = 3;
                                        setOpened(false);
                                        setUpdateState(!updateState);
                                    },
                                    (errorMessage: string) => {
                                        setOpened(false);
                                        toast.error(errorMessage);
                                    },
                                ),
                            );
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeletePayrollAction;
